export default [
  { x: 0, y: 8, type: 'tree' },
  { x: 0, y: 9, type: 'tree' },
  { x: 0, y: 10, type: 'tree' },
  { x: 1, y: 8, type: 'tree' },
  { x: 1, y: 9, type: 'tree' },
  { x: 1, y: 10, type: 'tree' },
  { x: 2, y: 7, type: 'tree' },
  { x: 2, y: 8, type: 'tree' },
  { x: 2, y: 9, type: 'tree' },
  { x: 3, y: 7, type: 'tree' },
  { x: 3, y: 8, type: 'tree' },
  { x: 3, y: 9, type: 'tree' },
  { x: 4, y: 8, type: 'tree' },
  { x: 4, y: 9, type: 'tree' },
  { x: 5, y: 7, type: 'tree' },
  { x: 5, y: 8, type: 'tree' },
  { x: 5, y: 9, type: 'tree' },
  { x: 5, y: 12, type: 'water' },
  { x: 5, y: 13, type: 'water' },
  { x: 5, y: 14, type: 'water' },
  { x: 6, y: 1, type: 'mountain' },
  { x: 6, y: 2, type: 'mountain' },
  { x: 6, y: 3, type: 'mountain' },
  { x: 6, y: 8, type: 'tree' },
  { x: 6, y: 9, type: 'tree' },
  { x: 6, y: 10, type: 'tree' },
  { x: 6, y: 12, type: 'water' },
  { x: 6, y: 13, type: 'water' },
  { x: 6, y: 14, type: 'water' },
  { x: 7, y: 0, type: 'mountain' },
  { x: 7, y: 4, type: 'mountain' },
  { x: 7, y: 8, type: 'tree' },
  { x: 7, y: 9, type: 'tree' },
  { x: 7, y: 10, type: 'tree' },
  { x: 7, y: 12, type: 'water' },
  { x: 7, y: 13, type: 'water' },
  { x: 8, y: 4, type: 'mountain' },
  { x: 8, y: 10, type: 'water' },
  { x: 8, y: 11, type: 'water' },
  { x: 8, y: 12, type: 'water' },
  { x: 9, y: 1, type: 'canoe' },
  { x: 9, y: 4, type: 'mountain' },
  { x: 9, y: 10, type: 'water' },
  { x: 9, y: 11, type: 'water' },
  { x: 9, y: 12, type: 'water' },
  { x: 10, y: 3, type: 'mountain' },
  { x: 10, y: 9, type: 'water' },
  { x: 10, y: 10, type: 'water' },
  { x: 11, y: 1, type: 'mountain' },
  { x: 11, y: 2, type: 'mountain' },
  { x: 11, y: 9, type: 'water' },
  { x: 11, y: 10, type: 'water' },
  { x: 12, y: 0, type: 'mountain' },
  { x: 12, y: 9, type: 'water' },
  { x: 12, y: 10, type: 'water' },
  { x: 13, y: 7, type: 'water' },
  { x: 13, y: 8, type: 'water' },
  { x: 13, y: 9, type: 'water' },
  { x: 14, y: 7, type: 'water' },
  { x: 14, y: 8, type: 'water' },
  { x: 14, y: 9, type: 'water' },
  { x: 15, y: 5, type: 'water' },
  { x: 15, y: 6, type: 'water' },
  { x: 15, y: 7, type: 'water' },
  { x: 16, y: 5, type: 'water' },
  { x: 16, y: 6, type: 'water' },
  { x: 16, y: 7, type: 'water' },
  { x: 17, y: 4, type: 'water' },
  { x: 17, y: 5, type: 'water' },
  { x: 18, y: 3, type: 'water' },
  { x: 18, y: 4, type: 'water' },
  { x: 18, y: 5, type: 'water' },
  { x: 19, y: 3, type: 'water' },
  { x: 19, y: 4, type: 'water' },
  { x: 19, y: 5, type: 'water' },
  { x: 19, y: 14, type: 'house' }
]